import shiftRequestService from "../services/shiftRequestService";
import {action} from "mobx";
import appStore from "./appStore";
import {message} from "antd";

class shiftRequestStore {
    @action getShiftRequestList = async params => {
        try {
            const resultOfRequest = await shiftRequestService.getShiftRequestList(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: error?.message || "Bir hata oluştu"});
            return false;
        }
    };

    @action createShiftRequest = async params => {
        try {
            const resultOfRequest = await shiftRequestService.createShiftRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action cancelShiftRequest = async params => {
        try {
            const resultOfRequest = await shiftRequestService.cancelShiftRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            message.success(`Talep iptal edildi.`);
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getShiftRequestDetails = async params => {
        try {
            const resultOfRequest = await shiftRequestService.getShiftRequestDetails(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: "Talep detayları yüklenirken bir hata oluştu."});
            return false;
        }
    };

    @action createShiftRequestNote = async params => {
        try {
            const resultOfRequest = await shiftRequestService.createShiftRequestNote(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateRequestStatus = async params => {
        try {
            const resultOfRequest = await shiftRequestService.updateRequestStatus(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action exportShiftRequestExcel = async params => {
        try {
            const resultOfRequest = await shiftRequestService.exportShiftRequestExcel(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return resultOfRequest;
            }
            return resultOfRequest;
        } catch (error) {
            appStore.openErrorModal({
                content: error.message || "Excel dosyası indirirken bir hata oluştu."
            });
            return {status: 500, data: {message: error.message}};
        }
    };
}

export default new shiftRequestStore();
